@if (project) {
  <hawk-record-navigation
    class="app-page common_style"
    [breadcrumbLinkList]="[{ description: 'Projekte', link: '/a/projekt' }]"
    [root]="'project'"
    [leafDescription]="project.name"
  >
    <div slot="toolbar" class="flex flex-row gap-2">
      <a class="bm-btn" [routerLink]="'/project-temp/' + project.id">
        <fa-icon [icon]="faUpload" />
        Workflow-Upload
      </a>
      <div
        data-tip="Projekte können nur gelöscht werden, wenn keine Abhängigkeiten zu TODO vorhanden sind"
        [class.bm-tooltip]="projectIsDeletable"
        class="bm-tooltip-left"
      >
        <button class="bm-btn bm-btn-error" [disabled]="!projectIsDeletable" (click)="deleteProject()">
          <fa-icon [icon]="faTrash" />
          Löschen
        </button>
      </div>
    </div>
    <div class="page-content page-frame">
      <div class="h-full page-sheet grid grid-cols-2 gap-4">
        <div class="position-relative h-100">
          <div
            class="position-absolute"
            style="top: 0; left: 0; bottom: 0; right: 0; border: 1px solid #ccc; border-radius: 8px"
          >
            <div class="position-absolute" style="top: -1px; left: -1px; z-index: 2">
              <div role="tablist" class="bm-tabs bm-tabs-lift w-full">
                <a role="tab" class="bm-tab" [class.bm-tab-active]="editEditorPages" (click)="showEditEditorPages()">
                  <fa-icon class="me-2 my-auto" [icon]="faCog"></fa-icon> Seiten-Einstellungen
                </a>
                @for (page of project.editor_pages; track page) {
                  <a
                    role="tab"
                    class="bm-tab"
                    [class.bm-tab-active]="shownEditorPage == page"
                    (click)="selectEditorPage(page)"
                  >
                    {{ page.name }}
                  </a>
                }
              </div>
            </div>
            @if (editEditorPages) {
              <div class="d-flex absolute" style="top: 0; left: 0; bottom: 0; right: 0">
                <div class="m-auto">
                  <ng-container [ngTemplateOutlet]="tplEditEditorPages" />
                </div>
              </div>
            } @else {
              <hawk-editor-js
                class="h-100"
                [initialData]="shownEditorPage?.data"
                [byFileEndpoint]="editorJsImgEndpoint"
                (saveContent)="onEditorJsSave($event)"
              ></hawk-editor-js>
            }
          </div>
        </div>
        <div class="flex flex-col min-h-0 overflow-hidden">
          <div role="tablist" class="bm-tabs bm-tabs-lift w-full shrink-0">
            <a role="tab" class="bm-tab" [class.bm-tab-active]="selectedTab === 'data'" (click)="selectTab('data')">
              Daten
            </a>
            <a
              role="tab"
              class="bm-tab"
              [class.bm-tab-active]="selectedTab === 'tickets'"
              (click)="selectTab('tickets')"
            >
              Tickets
            </a>
            <a
              role="tab"
              class="bm-tab"
              [class.bm-tab-active]="selectedTab === 'technicians'"
              (click)="selectTab('technicians')"
            >
              Projekt-Techniker
            </a>
            <a role="tab" class="bm-tab" [class.bm-tab-active]="selectedTab === 'stores'" (click)="selectTab('stores')">
              Filialen
            </a>
            <a
              role="tab"
              class="bm-tab"
              [class.bm-tab-active]="selectedTab === 'material-requirements'"
              (click)="selectTab('material-requirements')"
            >
              Materialanforderungen
            </a>
            @if (project.is_dismantling_project) {
              <a
                role="tab"
                class="bm-tab"
                [class.bm-tab-active]="selectedTab === 'dismantling-articles'"
                (click)="selectTab('dismantling-articles')"
              >
                Rückbau-Artikel
              </a>
            }
            <a
              role="tab"
              class="bm-tab"
              [class.bm-tab-active]="selectedTab === 'staging'"
              (click)="selectTab('staging')"
            >
              Staging
            </a>
          </div>
          <div class="flex flex-col flex-1 min-h-0 bm-tab-content bg-base-100 overflow-y-auto">
            @switch (selectedTab) {
              @case ("data") {
                <ng-container [ngTemplateOutlet]="tplTabData" />
              }
              @case ("material-requirements") {
                <ng-container [ngTemplateOutlet]="tplMaterialRequirements" />
              }
              @case ("tickets") {
                <ng-container [ngTemplateOutlet]="tplTabTickets" />
              }
              @case ("technicians") {
                <ng-container [ngTemplateOutlet]="tplTabTechnicians" />
              }
              @case ("stores") {
                <ng-container [ngTemplateOutlet]="tplTabStores" />
              }
              @case ("dismantling-articles") {
                <app-dismantling-articles-tab class="flex-1 min-h-0" [projectId]="project.id" />
              }
              @case ("staging") {
                <app-staging-config-tab class="flex-1 min-h-0" [projectId]="project.id" />
              }
            }
          </div>
        </div>
        <!-- <div class="tabs flex_col">
        <div class="tablist" role="tablist">
          <button role="tab" class="tab" [attr.aria-selected]="selectedTab == 'tickets'" (click)="selectTab('tickets')">
            Tickets
          </button>
          <button
            role="tab"
            class="tab"
            [attr.aria-selected]="selectedTab == 'technicians'"
            (click)="selectTab('technicians')"
            >
            Projekt-Techniker
          </button>
          <button role="tab" class="tab" [attr.aria-selected]="selectedTab == 'stores'" (click)="selectTab('stores')">
            Filialen
          </button>
        </div>
        <div class="flex_col" style="width: calc(100% - 20px); margin: 10px; flex: 1">
          <ng-container *ngIf="selectedTab == 'tickets'">
            <ng-container [ngTemplateOutlet]="tplTabTickets" />
          </ng-container>
          <ng-container *ngIf="selectedTab == 'technicians'">
            <ng-container [ngTemplateOutlet]="tplTabTechnicians" />
          </ng-container>
          <ng-container *ngIf="selectedTab == 'stores'">
            <ng-container [ngTemplateOutlet]="tplTabStores" />
          </ng-container>
        </div>
      </div> -->
      </div>
    </div>
  </hawk-record-navigation>
}

@if (editTicketAttributes) {
  <dialog class="bm-modal" open (document:keydown.escape)="editTicketAttributes = false">
    <div
      class="bm-modal-box max-h-[80vh] min-h-[620px] overflow-y-auto w-full max-w-2xl"
      style="display: flex; flex-direction: column"
    >
      <h4 class="font-bold text-lg mb-2">Ticketattribute bearbeiten</h4>
      <div class="bm-alert bm-alert-error bm-alert-soft mb-4">
        <div>
          <h4 class="font-bold">Info</h4>
          <div class="text-xs mb-2">
            Jedes Ticket besitzt einen <b>Status</b> und eine <b>Priorität</b>, außerdem können dem Ticket mehrere
            <b>Aufgaben</b> zugeordnet werden.
          </div>
          <div class="text-xs mb-2">
            Beim Status können Sie festlegen, ob mit diesem das Ticket erledigt ist, welche Aufgaben standardmäßig damit
            verbunden sind und ob die Projektkontakte über das Erreichen per E-Mail benachrichtigt werden sollen.
          </div>
        </div>
      </div>
      <hawk-project-edit-ticket-attributes
        class="flex-grow-1"
        [project]="project"
        (updateProjectData)="updateProjectData($event)"
      />
      <div class="bm-modal-action">
        <button class="bm-btn bm-btn-primary" (click)="editTicketAttributes = false">Ok</button>
      </div>
    </div>
  </dialog>
}
@if (addMailTemplateForm) {
  <hawk-add-new-mail-template-modal
    [formGroup]="addMailTemplateForm"
    (newDBOutput)="updateProjectData($event)"
    (closeModal)="addMailTemplateForm = null"
  />
}
@if (editMailTemplateForm) {
  <hawk-edit-mail-template
    [formGroup]="editMailTemplateForm"
    (newDBOutput)="updateProjectData($event)"
    (closeModal)="editMailTemplateForm = null"
  />
}
@if (editDeadlineTemplate) {
  <hawk-edit-project-deadlines-modal [formGroup]="editDeadlineTemplate" (closeModal)="editDeadlineTemplate = null" />
}
@if (editProjectTechnicianForm) {
  <hawk-edit-project-technician-modal
    [userID]="editProjectTechnicianForm.controls['user_id'].value"
    [formGroup]="editProjectTechnicianForm"
    (closeModal)="editProjectTechnicianForm = null"
  />
}
@if (addMaterialRequirementForm) {
  <hawk-add-new-material-requirement-modal
    [formGroup]="addMaterialRequirementForm"
    [articleTemplates]="articleTemplates"
    (closeModal)="addMaterialRequirementForm = null"
    (newDBOutput)="onMaterialRequirementCreated($event)"
  />
}
@if (editMaterialRequirementForm) {
  <hawk-edit-material-requirement-modal
    [formGroup]="editMaterialRequirementForm"
    [articleTemplates]="articleTemplates"
    (closeModal)="editMaterialRequirementForm = null"
    (newDBOutput)="onMaterialRequirementUpdated($event)"
  />
}

<ng-template #tplStammdaten>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">Stammdaten</h3>
    <dl class="bm-dl">
      <dt (click)="editName = !editName">
        Name
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editName) {
          {{ project.name }}
        } @else {
          <hawk-shared-edit-input
            [textValue]="project.name"
            (saveClicked)="saveName($any($event))"
            (cancelClicked)="editName = false"
          />
        }
      </dd>
      <dt (click)="editActive = !editActive">
        Aktiv
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editActive) {
          @if (project.active) {
            <fa-icon [icon]="faCheck" />
          } @else {
            &#10060;
          }
        } @else {
          <hawk-shared-edit-input
            [modus]="'checkbox'"
            [boolValue]="project.active"
            (saveClicked)="saveActive($any($event))"
            (cancelClicked)="editActive = false"
          />
        }
      </dd>
      <dt (click)="editDescription = !editDescription">
        Beschreibung
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editDescription) {
          {{ project.description }}
        } @else {
          <hawk-shared-edit-input
            [textValue]="project.description"
            (saveClicked)="saveDescription($any($event))"
            (cancelClicked)="editDescription = false"
          />
        }
      </dd>
      <dt (click)="editFallbackDate = !editFallbackDate">
        Fallback-Datum
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editFallbackDate) {
          @if (project.fallback_date) {
            {{ project.fallback_date | date: "dd.MM.yyyy" }}
          } @else {
            <span class="text-base-content/60">nicht gesetzt</span>
          }
        } @else {
          <hawk-shared-edit-input
            [modus]="'date'"
            [dateValue]="$any(project.fallback_date)"
            (saveClicked)="saveFallbackDate($any($event))"
            (cancelClicked)="editFallbackDate = false"
          />
        }
      </dd>
      <dt (click)="editCustomer = !editCustomer">
        Kunde
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editCustomer) {
          <a [routerLink]="'/kunde/' + project.customer.id">
            <fa-icon [icon]="faIndustry" />
            {{ project.customer.name }}
          </a>
        } @else {
          <hawk-shared-edit-input
            [selectValue]="project.customer.id"
            [modus]="'select'"
            [selectOptions]="customers"
            (saveClicked)="saveCustomer($any($event))"
            (cancelClicked)="editCustomer = false"
          />
        }
      </dd>
      <dt (click)="editType = !editType">
        Typ
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editType) {
          {{ projectTypeTranslations[project.type].name }}
        } @else {
          <hawk-shared-edit-input
            [selectValue]="selectedProjectTypeID"
            [modus]="'select'"
            [selectOptions]="selectableProjectTypes"
            (saveClicked)="saveType($any($event))"
            (cancelClicked)="editType = false"
          />
        }
      </dd>
      <dt (click)="editDismantlingProject = !editDismantlingProject">
        Rückbauprojekt
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editDismantlingProject) {
          @if (project.is_dismantling_project) {
            <fa-icon [icon]="faCheck" />
          } @else {
            -
          }
        } @else {
          <hawk-shared-edit-input
            [modus]="'checkbox'"
            [boolValue]="project.is_dismantling_project"
            (saveClicked)="saveDismantlingProject($any($event))"
            (cancelClicked)="editDismantlingProject = false"
          />
        }
      </dd>
      <dt (click)="editCostCenter = !editCostCenter">
        Kostenstelle
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editCostCenter) {
          {{ project.cost_center }}
        } @else {
          <hawk-shared-edit-input
            [textValue]="project.cost_center"
            (saveClicked)="saveCostCenter($any($event))"
            (cancelClicked)="editCostCenter = false"
          />
        }
      </dd>
      <dt (click)="editCutOffTime = !editCutOffTime">
        Cut off time (SLA +1Tag)
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editCutOffTime) {
          {{ project.cut_off_time }}
        } @else {
          <hawk-shared-edit-input
            [timeValue]="project.cut_off_time"
            [modus]="'time'"
            [selectOptions]="customers"
            (saveClicked)="saveCutOffTime($any($event))"
            (cancelClicked)="editCutOffTime = false"
          />
        }
      </dd>
      <dt (click)="editDispatchers = !editDispatchers">
        Dispatcher
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editDispatchers) {
          <div class="flex flex-row gap-1 flex-wrap">
            @for (dispatcher of project.dispatchers; track $index) {
              <a [routerLink]="'/benutzer/' + dispatcher.id" class="bm-link bm-link-hover">
                <fa-icon [icon]="faUser" />
                {{ dispatcher.name }}
              </a>
            }
          </div>
        } @else {
          <hawk-shared-edit-input
            [multiSelectValue]="selectedDispatcherIds"
            [modus]="'multiselect'"
            [selectOptions]="dispatchers"
            (saveClicked)="saveDispatchers($any($event))"
            (cancelClicked)="editDispatchers = false"
          />
        }
      </dd>
    </dl>
  </section>
</ng-template>

<ng-template #tplLogo>
  <section class="bm-card bm-card-sm bm-crad-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100 left-4">
      Logo
      <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="openLogoUpload()" type="button">
        <fa-icon [icon]="['far', 'edit']"></fa-icon>
      </button>
      <input #fileInput type="file" accept="image/*" style="display: none" (change)="onLogoSelected($event)" />
    </h3>
    <img style="cursor: pointer" [src]="project.logo" alt="Projekt-Logo" (click)="openLogoUpload()" />
  </section>
</ng-template>

<ng-template #tplDocs>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">Dokumentation</h3>
    <dl class="bm-dl overflow-clip">
      <dt (click)="editDocumentation = !editDocumentation">
        Link
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editDocumentation) {
          @if (project.additional_documentation) {
            <div class="overflow-hidden overflow-ellipsis">
              <a [href]="project.additional_documentation" class="bm-link bm-link-hover break-words" target="_blank">
                {{ project.additional_documentation }}
              </a>
            </div>
          }
        } @else {
          <hawk-shared-edit-input
            [textValue]="project.additional_documentation"
            (saveClicked)="saveDocumentation($any($event))"
            (cancelClicked)="editDocumentation = false"
          />
        }
      </dd>
    </dl>
  </section>
</ng-template>
<!--
<section>
  <h2 class="flex_row">
    <div>Deadline-Vorgaben</div>
    <div class="pseudo-link" (click)="openEditDeadlineModal()">Bearbeiten</div>
  </h2>
  <table class="section_table">
    <tbody>
      <tr>
        <td>Deadline 1 verwenden</td>
        <td *ngIf="project.use_deadline"><fa-icon [icon]="faCheck"></fa-icon></td>
        <td *ngIf="!project.use_deadline"> - </td>
      </tr>
      <tr>
        <td>Deadline 2 verwenden</td>
        <td *ngIf="project.use_deadline2"><fa-icon [icon]="faCheck"></fa-icon></td>
        <td *ngIf="!project.use_deadline2"> - </td>
      </tr>
      <tr>
        <td>Deadline 3 verwenden</td>
        <td *ngIf="project.use_deadline3"><fa-icon [icon]="faCheck"></fa-icon></td>
        <td *ngIf="!project.use_deadline3"> - </td>
      </tr>
    </tbody>
  </table>
</section>
-->
<ng-template #tplKontakt>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">Kontakt</h3>
    <dl class="bm-dl">
      <dt (click)="editContact = !editContact">
        Daten
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editContact) {
          {{ project.contact }}
        } @else {
          <hawk-shared-edit-input
            [textValue]="project.contact"
            (saveClicked)="saveContact($any($event))"
            (cancelClicked)="editContact = false"
          />
        }
      </dd>
      <dt (click)="editEmail = !editEmail">
        Email
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editEmail) {
          @if (project.email) {
            @for (mail of project.email.split(";"); track $index) {
              <a class="block bm-link bm-link-hover" [href]="'mailto:' + mail">{{ mail }}</a>
            }
          }
        } @else {
          <hawk-shared-edit-input
            [textValue]="project.email"
            (saveClicked)="saveEmail($any($event))"
            (cancelClicked)="editEmail = false"
          />
        }
      </dd>
    </dl>
  </section>
</ng-template>

<ng-template #tplTicketAttributes>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100" (click)="editTicketAttributes = !editTicketAttributes">
      Ticketattribute
      <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
        <fa-icon [icon]="['far', 'edit']" />
      </button>
    </h3>
    <dl class="bm-dl">
      <dt>Status</dt>
      <dd>{{ project.status.length }}</dd>
      <!-- <dt>Aufgaben</dt>
      <dd>{{project.tasks.length}}</dd> -->
      <dt>Prioritäten</dt>
      <dd>{{ project.priorities.length }}</dd>
    </dl>
  </section>
</ng-template>

<ng-template #tplMailNotifications>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">
      Mailbenachrichtigungen
      <fa-icon
        [icon]="faInfoCircle"
        class="cursor-pointer bm-tip"
        data-tip="Techniker eines Einsatzes erhalten bei folgenden Ereignissen eine E-Mail."
      />
    </h3>
    <dl class="bm-dl">
      <dt (click)="editSendOperationNew = !editSendOperationNew">
        Neuer Einsatz
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editSendOperationNew) {
          @if (project.send_operation_new) {
            <fa-icon [icon]="faCheck" />
          } @else {
            -
          }
        } @else {
          <hawk-shared-edit-input
            [modus]="'checkbox'"
            [boolValue]="project.send_operation_new"
            (saveClicked)="saveSendOperationNew($any($event))"
            (cancelClicked)="editSendOperationNew = false"
          />
        }
      </dd>
      <dt (click)="editSendOperationUpdate = !editSendOperationUpdate">
        Einsatz geändert
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editSendOperationUpdate) {
          @if (project.send_operation_update) {
            <fa-icon [icon]="faCheck" />
          } @else {
            -
          }
        } @else {
          <hawk-shared-edit-input
            [modus]="'checkbox'"
            [boolValue]="project.send_operation_update"
            (saveClicked)="saveSendOperationUpdate($any($event))"
            (cancelClicked)="editSendOperationUpdate = false"
          />
        }
      </dd>
      <dt (click)="editSendOperationDelete = !editSendOperationDelete">
        Einsatz gelöscht (Storno)
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editSendOperationDelete) {
          @if (project.send_operation_delete) {
            <fa-icon [icon]="faCheck" />
          } @else {
            -
          }
        } @else {
          <hawk-shared-edit-input
            [modus]="'checkbox'"
            [boolValue]="project.send_operation_delete"
            (saveClicked)="saveSendOperationDelete($any($event))"
            (cancelClicked)="editSendOperationDelete = false"
          />
        }
      </dd>
    </dl>
  </section>
</ng-template>

<ng-template #tplMailTemplates>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">
      Mailtemplates
      <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="openAddMailTemplateForm()">
        <fa-icon [icon]="['far', 'plus']" />
      </button>
    </h3>
    <table class="bm-tabme bm-table-xs">
      <tbody>
        @for (template of project.mail_templates; track $index) {
          <tr>
            <td>
              <div
                style="
                  background-color: #757575;
                  color: white;
                  width: fit-content;
                  border-radius: 4px;
                  padding: 4px 8px;
                "
              >
                {{ template.type }}
              </div>
            </td>
            <td>{{ template.subject }}</td>
            <td style="text-align: right">
              <div class="flex_row gap-4">
                <fa-icon class="pseudo-link mr8" [icon]="faPen" (click)="openEditMailTemplateForm(template)"></fa-icon>
                <fa-icon class="pseudo-link mr4" [icon]="faTrash" (click)="deleteMailTemplate(template)"></fa-icon>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </section>
</ng-template>

<ng-template #tplStatus>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">Status</h3>
    @for (status_count of statusCounts; track $index) {
      <div class="flex flex-col w-full">
        <div class="flex flex-row">
          <div style="margin-right: auto">
            <a [href]="'/a/ticket/suche?project_id=' + project.id + '&status_id=' + status_count.id">
              {{ status_count.name }}
            </a>
            @if (status_count.closed) {
              <fa-icon
                [tooltip]="'Closed'"
                class="text-success"
                style="cursor: pointer; margin-left: 6px"
                [icon]="faCheckCircle"
              />
            }
          </div>
          <div style="font-weight: bold">
            {{ status_count.count }}
          </div>
        </div>
        <mat-progress-bar
          [class]="status_count.closed ? 'green_bar' : 'orange_bar'"
          mode="determinate"
          [value]="(status_count.count / tickets.length) * 100"
        />
      </div>
    }
  </section>
</ng-template>

<ng-template #tplTasks>
  @if (taskCounts.length) {
    <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
      <h3 class="bm-card-title bm-card-title-top bg-base-100">Aufgaben</h3>
      @for (task_count of taskCounts; track $index) {
        <div class="flex flex-col w-full text-xs">
          <div class="flex flex-row">
            <div class="text-muted" style="margin-right: auto">
              {{ task_count.name }}
            </div>
            <div style="font-weight: bold">
              {{ task_count.count }}
            </div>
          </div>
          <mat-progress-bar
            [class]="'blue_bar'"
            mode="determinate"
            [value]="(task_count.count / totalTaskCount) * 100"
          />
        </div>
      }
    </section>
  }
</ng-template>

<ng-template #tplPriorities>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">Prioritäten</h3>
    @for (priority_count of priorityCounts; track $index) {
      <div class="flex flex-col w-full text-xs">
        <div class="flex_row">
          <div style="margin-right: auto">
            <a [href]="'/a/ticket/suche?project_id=' + project.id + '&priority_id=' + priority_count.id">{{
              priority_count.name
            }}</a>
          </div>
          <div style="font-weight: bold">
            {{ priority_count.count }}
          </div>
        </div>
        <mat-progress-bar
          [class]="'blue_bar'"
          mode="determinate"
          [value]="(priority_count.count / tickets.length) * 100"
        />
      </div>
    }
  </section>
</ng-template>

<ng-template #tplTabTickets>
  <div class="flex flex-row items-center py-2 gap-2">
    <a [href]="'/a/ticket/suche?project_id=' + project.id" class="bm-badge bm-badge-secondary">
      Gesamt {{ tickets.length }}
    </a>
    <a [href]="'/a/ticket/suche?project_id=' + project.id + '&is_open=1'" class="bm-badge bm-badge-secondary">
      Offen {{ openTicketCount }}
    </a>
    <a [href]="'/a/ticket/suche?project_id=' + project.id + '&is_open=0'" class="bm-badge bm-badge-secondary">
      Geschlossen {{ closedTicketCount }}
    </a>

    <a [routerLink]="['/projekt', project.id, 'ticket_import']" class="bm-btn bm-btn-primary">
      Ticket-Import
      <fa-icon [icon]="faUpload" />
    </a>
    <span class="flex-1"></span>
    <input
      type="text"
      class="bm-input w-52"
      placeholder="Schnellfilter..."
      (input)="ticketQuickSearchChanged($event)"
    />
  </div>
  <ag-grid-angular
    class="ag-theme-quartz flex-fill"
    style="flex: 1; width: 100%"
    [rowData]="tickets"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="ticketColDefs"
    [rowClassRules]="rowClassRules"
    [pagination]="true"
    [rowSelection]="rowSelection"
    [autoSizeStrategy]="autoSizeStrategy"
    [paginationPageSize]="128"
    [localeText]="locale"
    [sideBar]="sideBarOptions"
    [paginationPageSizeSelector]="[16, 32, 64, 128]"
    (gridReady)="onTicketGridReady($event)"
  >
  </ag-grid-angular>
</ng-template>

<ng-template #tplTabTechnicians>
  <div class="flex flex-row gap-2 py-2">
    <button class="bm-btn" (click)="activateBentomaxProjectTechnicians()">Bentomax-Techniker Aktivieren</button>
    <div class="flex-fill"></div>
    <button
      class="bm-btn bm-btn-primary"
      [disabled]="projectTechnicianForm.untouched || !projectTechnicianForm.valid"
      (click)="saveProjectTechnicianFormState()"
    >
      Speichern
    </button>
    @if (projectTechnicianFormCellInputs.length != 0) {
      <input class="bm-input w-52" placeholder="Schnellfilter" (input)="projectTechnicianQuickSearchChanged($event)" />
    }
  </div>
  <ag-grid-angular
    class="ag-theme-quartz"
    style="flex: 1; width: 100%"
    [rowData]="projectTechnicianFormCellInputs"
    [theme]="oldTheme"
    [loadThemeGoogleFonts]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="projectTechnicianColDefs"
    [rowClassRules]="rowClassRules"
    [pagination]="true"
    [context]="getProjectTechnicianContext()"
    [components]="getAGComponents()"
    [getRowId]="getProjectTechnicianRowNodeId"
    [rowSelection]="rowSelection"
    [autoSizeStrategy]="autoSizeStrategy"
    [paginationPageSize]="100"
    [localeText]="locale"
    [sideBar]="sideBarOptions"
    [paginationPageSizeSelector]="[10, 25, 100]"
    (gridReady)="onProjectTechnicianGridReady($event)"
    (rowDataUpdated)="initProjectTechnicianFormControls()"
  />
</ng-template>

<ng-template #tplTabStores>
  <div class="flex flex-row gap-2 py-2">
    <div class="flex flex-row gap-2 items-start">
      <button class="bm-btn" (click)="activateAllProjectStores()">Alle auswählen</button>
      <span class="flex-1"></span>
      <button
        type="button"
        class="bm-btn bm-btn-primary"
        (click)="saveStoreFormState()"
        [disabled]="projectStoreForm.untouched || !projectStoreForm.valid"
      >
        Speichern
      </button>

      <input class="bm-input w-52" placeholder="Schnellfilter" (input)="storeQuickSearchChanged($event)" />
    </div>
    @if (isSavingStores) {
      <div class="flex flex-col gap-1 bg-base-200 rounded p-2 text-xs border border-base-300">
        <div class="flex flex-row">
          <div>Änderungen werden gespeichert…</div>
          <div class="ml-auto font-bold">
            {{ (storeSaveTotal ? (storeSaveProgress / storeSaveTotal) * 100 : 0) | number: "1.0-0" }}%
          </div>
        </div>

        <div class="w-full h-2 bg-base-300 rounded overflow-hidden">
          <div
            class="h-full bg-primary"
            [style.width.%]="storeSaveTotal ? (storeSaveProgress / storeSaveTotal) * 100 : 0"
            style="transition: width 0.15s linear"
          ></div>
        </div>

        <div>{{ storeSaveProgress }} / {{ storeSaveTotal }} verarbeitet</div>
      </div>
    }
  </div>

  <ag-grid-angular
    class="ag-theme-quartz"
    style="flex: 1; width: 100%"
    [rowData]="projectStoreFormCellInputs"
    [theme]="oldTheme"
    [loadThemeGoogleFonts]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="projectStoreColDefs"
    [rowClassRules]="rowClassRules"
    [pagination]="true"
    [context]="getProjectStoreContext()"
    [components]="getAGComponents()"
    [getRowId]="getStoreRowNodeId"
    [rowSelection]="rowSelection"
    [autoSizeStrategy]="autoSizeStrategy"
    [paginationPageSize]="100"
    [localeText]="locale"
    [sideBar]="sideBarOptions"
    [paginationPageSizeSelector]="[10, 25, 100]"
    [rowBuffer]="100"
    (gridReady)="onProjectStoreGridReady($event)"
  />
</ng-template>

<ng-template #tplTabData>
  <div class="h-100 position-relative">
    <div class="position-absolute overflow-y-auto" style="top: 0; left: 0; right: 0; bottom: 0">
      <div class="grid grid-cols-2 gap-4 py-2 mt-2">
        <div class="flex flex-col row-span-4 gap-4">
          <ng-container [ngTemplateOutlet]="tplLogo" />
          <ng-container [ngTemplateOutlet]="tplStammdaten" />
        </div>
        <ng-container [ngTemplateOutlet]="tplKontakt" />
        <div class="flex flex-row gap-4">
          <ng-container [ngTemplateOutlet]="tplDocs" />
          <div class="w-20 h-100 flex">
            <ng-container [ngTemplateOutlet]="tplColor" />
          </div>
        </div>
        <ng-container [ngTemplateOutlet]="tplTicketAttributes" />
        <!--<ng-container [ngTemplateOutlet]="tplMailNotifications" />-->
        <ng-container [ngTemplateOutlet]="tplMailTemplates" />
        <ng-container [ngTemplateOutlet]="tplStatus" />
        <!--<ng-container [ngTemplateOutlet]="tplTasks" />-->
        <ng-container [ngTemplateOutlet]="tplPriorities" />
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tplColor>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300 flex">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">Farbe</h3>
    <input
      class="bm-input mx-auto"
      style="height: 24px"
      type="color"
      [ngModel]="project.color"
      (change)="saveColor($event)"
    />
  </section>
</ng-template>

<ng-template #tplEditEditorPages>
  <div class="mt-2 space-y-3" style="max-height: 800px; overflow-y: auto">
    <div class="flex items-center justify-between">
      <button type="button" class="px-3 py-1 bm-btn bm-btn-primary" style="margin-left: auto" (click)="addPage()">
        + Neue Seite
      </button>
    </div>
    @if (project.editor_pages?.length) {
      <table class="w-full text-sm rounded-md" style="border: 1px solid lightgray">
        <thead class="bg-gray-50">
          <tr>
            <th class="p-2 text-left">Reihenfolge</th>
            <th class="p-2 text-left">Name</th>
            <th class="p-2 text-left">Aktionen</th>
          </tr>
        </thead>
        <tbody>
          @for (
            page of project.editor_pages;
            track page.id ?? $index;
            let i = $index;
            let last = $last;
            let first = $first
          ) {
            <tr class="border-t" style="border-color: lightgray !important">
              <td class="p-2">
                <div class="flex items-center gap-2">
                  <div class="flex flex-row">
                    <button
                      type="button"
                      class="px-2 py-1 border rounded me-1 disabled:opacity-40"
                      (click)="moveUp(i)"
                      [disabled]="first"
                      aria-label="Nach oben"
                    >
                      ↑
                    </button>
                    <button
                      type="button"
                      class="px-2 py-1 border rounded disabled:opacity-40"
                      (click)="moveDown(i)"
                      [disabled]="last"
                      aria-label="Nach unten"
                    >
                      ↓
                    </button>
                  </div>
                </div>
              </td>

              <td class="p-2">
                <input
                  type="text"
                  class="w-full px-2 py-1 border rounded"
                  [(ngModel)]="page.name"
                  (blur)="renamePage(i, page.name)"
                  placeholder="Name der Seite"
                />
              </td>

              <td class="p-2">
                <div class="d-flex flex_row">
                  <button type="button" class="px-3 py-1 bm-btn bm-btn-error my-auto" (click)="openDeletePageDialog(i)">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</ng-template>

<ng-template #tplMaterialRequirements>
  <div class="flex flex-row py-2">
    <button class="bm-btn" (click)="openAddMaterialRequirementForm()">Anforderung hinzufügen</button>
  </div>
  <ag-grid-angular
    class="ag-theme-quartz flex-fill"
    style="flex: 1; width: 100%"
    [rowData]="materialRequirementData"
    [theme]="oldTheme"
    [loadThemeGoogleFonts]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="materialRequirementColDefs"
    [rowClassRules]="rowClassRules"
    [rowSelection]="rowSelection"
    [autoSizeStrategy]="autoSizeStrategy"
    [paginationPageSize]="128"
    [localeText]="locale"
    [sideBar]="sideBarOptions"
    [paginationPageSizeSelector]="[16, 32, 64, 128]"
    (gridReady)="onMaterialRequirementsGridReady($event)"
  >
  </ag-grid-angular>
</ng-template>
